module.exports = __webpack_public_path__ + "static/a3-04737f125169fac6fe823b7ebafb334d.png";